import script from "./applyComplaintDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./applyComplaintDetails.vue?vue&type=script&setup=true&lang=js"

import "./applyComplaintDetails.vue?vue&type=style&index=0&id=2f882e8c&lang=scss"
import "./applyComplaintDetails.vue?vue&type=style&index=1&id=2f882e8c&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f882e8c"]])

export default __exports__